import { render, staticRenderFns } from "./WarningSolidIcon.vue?vue&type=template&id=6c8a2476&"
import script from "./WarningSolidIcon.vue?vue&type=script&lang=js&"
export * from "./WarningSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports